import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { Permission } from '../../models/principal/permission';
import { SidenavService } from '../../services/util/sidenav.service';
import { translate } from '@jsverse/transloco';
import { ContactUsDialogComponent } from '../../layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Permissions } from 'src/app/models/principal/permission';
import { PermissionsService } from 'src/app/services/util/permissions.service';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE
  },
];

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  tenant: string;
  enterpriseClient: boolean;

  RouterSegments = RouterSegments;
  permissionsMap: { [key: string]: boolean };
  PermissionKeys = PermissionKeys;

  constructor(private authService: AuthService, private router: Router, private sidenavService: SidenavService, 
    private readonly titleService: Title, private readonly route: ActivatedRoute, private permissionsService: PermissionsService) {
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    this.titleService.setTitle(this.route.snapshot.data.title);
    this.tenant = this.authService.principal.provider;
    this.enterpriseClient = !this.authService.hasPermission(Permission.VIEW_ENTERPRISE_PROSPECT);
  }

  goToComposeService(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.COMPOSE]);
  }

  goToReadMore(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.COMPOSABLE_BANKING]);
  }

  openContactForm(): void {
    const data = {
      title: translate('TOOLBAR.CONTACT_SALES'),
      submit: translate('BUTTONS.SEND')
    };
    // this.sidenavService.openInRightSidenav(ContactUsDialogComponent,data);
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }
}
